var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',_vm._l((_vm.titleArr),function(item,index){return _c('span',{key:index,class:{'title':true,'active':_vm.tab === index},on:{"click":function($event){return _vm.changeTab(index,item)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }